export default __webpack_public_path__ + "static/media/metamask.311a962c.png";